import React from "react";
import {Link} from 'react-router-dom';
import { Home,ShoppingBag,Settings,Power, Lock, User, Heart, MapPin} from 'react-feather';
function Sidebar(){
    return (
            <ul className="navbar-nav flex-column w-100">
                <li className="nav-item mt-2">
                    <Link to="/customer/dashboard" className="nav-link" aria-current="true"><Home/> Dashboard</Link>
                </li>
                <li className="nav-item">
                    <Link to="/customer/orders" className="nav-link" aria-current="true"><ShoppingBag/> Orders</Link>
                </li>
                <li className="nav-item">
                    <Link to="/customer/wishlist" className="nav-link" aria-current="true"><Heart/> Wishlist</Link>
                </li>
                <li className="nav-item">
                    <Link to="/customer/profile" className="nav-link" aria-current="true"><User/> Profile</Link>
                </li>
                <li className="nav-item">
                    <Link to="/customer/reset-link" className="nav-link" aria-current="true"><Lock/> Change Password</Link>
                </li>
                <li className="nav-item">
                    <Link to="/customer/logout" className="nav-link" aria-current="true"><Power/> Logout</Link>
                </li>
            </ul> 

        
    )
}

export default Sidebar;